module.exports = __webpack_public_path__ + "static/media/logo.7d6810c5.png";